var colors = {
  inactive : '#618481',
  active   : '#96B2AF'
};
var is_mobile=false;


$(document).ready(function() {
  var maps_menu=$('.maps_menu');
  var map=$('#vmap');
  
  // active countries
  countries.active=[];
  $.each(countries.join,function(i,item) {
    // active countries
    countries.active=$.merge(countries.active,item);
  });
  // give every country a random icon
  countries.icons={};
  var icon=Math.floor(Math.random()*10);
  $.each(countries.names,function(i,item) {
    countries.icons[i]=icon;
    icon=(icon+1) % 10;
  });
  countries.highlight={};
  // console.log(countries);
  

  // content visible if a subpage is loaded
  if (! $('body').hasClass('module_homepage') ) {
    $('#content').removeClass('hidden');
  }
  
  // Menu info
  $('a',maps_menu).each(function(){
    $(this).append('<span class="hidden">&nbsp;|&nbsp;<span class="info">info</span></span>');
  }).hover(function(){
    var cc=uri2cc($(this).attr('href'));
    unhighlight_all();
    highlight_works(cc,false);
    $('#volunteer').add('#volunteer_in').addClass('hidden');
  },function(){
  });
  // Click on countries in menu shows where join & show names
  $('a',maps_menu).click(function(e){
    $('#content').addClass('hidden');
    $('a span',maps_menu).addClass('hidden');
    $('a',maps_menu).removeClass('current');
    $(this).addClass('current');
    if (is_mobile) {
      return true;
    }
    else {
      $('span',this).removeClass('hidden');
      if (! $(e.target).hasClass('info')) {
        e.preventDefault();
        unhighlight_all();
        $('#volunteer').add('#volunteer_in').addClass('hidden');
        var cc=uri2cc($(this).attr('href'));
        highlight_works(cc,true);
        return false;
      }
    }
  });
  
  
  // iconen
  $('.navbar.maps_menu li.tbl_countries').each(function(){
    var uri=$('a',this).attr('href');
    var cc=uri2cc(uri);
    $(this).prepend('<span class="work_icon" data-cc="'+cc+'" data-colorize="false"></span>');
  });
  $('.navbar.maps_menu li.tbl_countries .work_icon').country_icons({colorize:false});
  
  // Langswitch
  $('#langswitch a').click(function(event){
    event.preventDefault();
    var hidden=$('#content .text.hidden').add('#langswitch .hidden');
    var shown=$('#content .text').add('#langswitch a').not('.hidden');
    $(hidden).removeClass('hidden');
    $(shown).addClass('hidden');
    return false;
  });
  
  $('.close').click(function(e){
    e.preventDefault();
    var div=$(this).parents('div:first');
    $(div).addClass('hidden');
    return false;
  });
  
  
  /**
   * MAPS
   */
  // console.log(countries);
	$(map).vectorMap({
    map: 'world_en',
    backgroundColor: '#336666',
    borderColor: '#336666',
    color: colors.inactive,
    hoverColor: false,
    selectedColor: '#F00',
    enableZoom: true,
    showTooltip: false,
    // hover on map
    onRegionOver: function(event, code, region) {
      if (typeof(countries.active[code])!=='undefined') {
        highlight(code);
      }
      var from=countries.from[code];
      if (typeof(from)!=='undefined') {
        highlight(code);
      }
    },
    onRegionOut: function(event, code, region) {
      if ($('#volunteer').hasClass('hidden')) {
        unhighlight(code);
      }
      // $('#volunteer').addClass('hidden');
    },
    onRegionClick: function(event, code, region) {
      unhighlight_all();
      var from=countries.from[code];
      if (typeof(from)!=='undefined') {
        $('#volunteer_in').addClass('hidden');
        highlight(code);
        var html_from='';
        for (var i = 0; i < from.length; i++) {
          html_from+=countries.names[from[i]]+'<span class="work_icon" data-cc="'+from[i]+'"></span><br>';
        }
        if ($('#content').hasClass('hidden')) {
          $('#work_country').html(countries.names[code]);
          $('#from_country').html(html_from);
          $('#volunteer').removeClass('hidden');
          $('.work_icon').country_icons({colorize:false});
        }
      }
    },
    
	});
  // Toon landen waar wat gedaan kan worden
  for (var i = 0; i < countries.active.length; i++) {
    var o = {};
    o[countries.active[i]]=colors.active;
    $(map).vectorMap('set', 'colors', o);
  }
  // Highlight countries als info van land wordt getoond
  var url=location.href.substr( location.href.lastIndexOf('/')+1 );
  if (url!=="") {
    var cc=uri2cc(url);
    highlight_works(cc,true);
  }
  // Highlight countries in menu join where you can join & show names
  // $('a .info',maps_menu).hover(function(){
  //   $('#volunteer').add('#volunteer_in').addClass('hidden');
  //   var cc=uri2cc($(this).parents('a').attr('href'));
  //   highlight_works(cc);
  // },function(){
  //   var cc=uri2cc($(this).parents('a').attr('href'));
  //   var works=countries.join[cc];
  //   if (typeof(works)!=='undefined') {
  //     for (var i = 0; i < works.length; i++) {
  //       unhighlight(works[i]);
  //     }
  //   }
  //   $('#volunteer_in').addClass('hidden');
  // });
  
  function highlight_works(cc,info) {
    var works=countries.join[cc];
    if (typeof(works)!=='undefined') {
      $('#volunteer').addClass('hidden');
      var html_works='';
      for (var i = 0; i < works.length; i++) {
        highlight(works[i]);
        html_works+=countries.names[works[i]]+'<span class="work_icon" data-cc="'+works[i]+'"></span><br>';
      }
      if (info) {
        if ($('#content').hasClass('hidden')) {
          $('#own_country').html(countries.names[cc]);
          $('#join_country').html(html_works);
          $('#volunteer_in').removeClass('hidden');
          $('.work_icon').country_icons();
        }
      }
    }
  }
  
  
  // Move zoom buttons
  var zoomin=$('.jqvmap-zoomin');
  var zoomout=$('.jqvmap-zoomout');
  $(zoomin).addClass('fa fa-plus-circle fa-lg').html('');
  $(zoomout).addClass('fa fa-minus-circle fa-lg').html('');
  $('.zoombuttons').append(zoomin).append(zoomout);
  
  
  // Scrollbuttons
  $('.scroll').click(function(){
    var transform=get_transform();
    var dirx=parseFloat($(this).data('dirx')) * 25;
    var diry=parseFloat($(this).data('diry')) * 25;
    transform.translate.x = transform.translate.x + dirx;
    transform.translate.y = transform.translate.y + diry;
    set_transform(transform);
  });


  /**
   * Gallery
   */
  $('.gallery').gallery();

});

$(window).load(function() {
  sizeMap();
});

$(window).resize(function() {
  sizeMap();
});


function sizeMap() {
  var width=$(window).width();
  is_mobile=width<=480;
  
  $('#vmap').css({'width':width});
  var top = 625 - (width-1200)/4;
  if (width<=480) {
    top-=$('#menu').outerHeight();
  }
  $('#vmap svg').css({'top':-top});
}


function get_transform() {
  var transform=$('#vmap svg g').attr('transform');
  var matches=transform.match(/scale\(((.|\n)*?)\)\stranslate\(((.|\n)*?),\s((.|\n)*?)\)/);
  var result = {
    scale : parseFloat(matches[1]),
    translate : {
      x : parseFloat(matches[3]),
      y : parseFloat(matches[5]),
    }
  };
  return result;
}

function set_transform(transform) {
  $('#vmap svg g').attr('transform','scale('+transform.scale+') translate('+transform.translate.x+', '+transform.translate.y+')');
}



function uri2cc(uri) {
  return uri.replace(/.*map_(\w{2}).*/g, "$1");
}
function highlight(cc) {
  var o = {};
  o[cc]=countries.colors[cc];
  $('#vmap').vectorMap('set', 'colors', o);
  countries.highlight[cc]=true;
}
function unhighlight(cc) {
  var o = {};
  if (countries.active.indexOf(cc)>=0) {
    o[cc]=colors.active;
  }
  else {
    o[cc]=colors.inactive;
  }
  $('#vmap').vectorMap('set', 'colors', o);
  countries.highlight[cc]=false;
}
function unhighlight_all() {
  $.each(countries.highlight,function(cc,val){
    if (val) unhighlight(cc);
  });
  
}


//
// Random icons
//
(function($) {
  var defaults = {
    colorize : true,
    colors:{
      '#68A96F': '-25px',
      '#B18372': '-50px',
      '#B6AA74': '-75px',
      '#68B1B8': '-100px',
      '#B88DA0': '-125px'
    }
  };
  var opts;
  var self;
  var methods = {
    init : function( options ) {
      self=this;
   		opts = $.extend({}, defaults, options);
      $(self).each(function(){
        var cc=$(this).data('cc');
        if (typeof(cc)==='undefined') cc=uri2cc($(this).attr('class'));
        var shift_icon = countries.icons[cc] * 25;
        var color=countries.colors[cc];
        var shift_color = 0;
        var this_colorize=$(this).data('colorize');
        if (typeof(this_colorize)==='undefined') {
          this_colorize=opts.colorize;
        }
        if (this_colorize) shift_color = opts.colors[color];
        $(this).css({'background-position':-shift_icon+'px '+shift_color});
      });
      return self;
    }
    
  };
  $.fn.country_icons = function(methodOrOptions) {
     if ( methods[methodOrOptions] ) {
       return methods[ methodOrOptions ].apply( this, Array.prototype.slice.call( arguments, 1 ));
     } else if ( typeof methodOrOptions === 'object' || ! methodOrOptions ) {
       return methods.init.apply( this, arguments );
     } else {
       $.error( 'Method "' +  methodOrOptions + '" does not exist on jQuery.country_icons' );
     }    
   };  
})(jQuery);




//
// Gallery
//
(function($) {
  var defaults = {};
  var opts;
  var self;
  var methods = {
    init : function( options ) {
      self=this;
   		opts = $.extend({}, defaults, options);
      opts.count=$('img',self).length;
      opts.current=1;
      methods.show.call();
      $('.prev',self).click(function(event){
        event.preventDefault();
        opts.current--;
        methods.show.call();
        return false;
      });
      $('.next',self).click(function(event){
        event.preventDefault();
        opts.current++;
        methods.show.call();
        return false;
      });
      
      return self;
    },
    
    show : function() {
      if (opts.current>opts.count) opts.current=1;
      if (opts.current<1) opts.current=opts.count;
      $('img',self).addClass('hidden');
      $('img:nth-child('+opts.current+')',self).removeClass('hidden');
    }
    
  };
  $.fn.gallery = function(methodOrOptions) {
     if ( methods[methodOrOptions] ) {
       return methods[ methodOrOptions ].apply( this, Array.prototype.slice.call( arguments, 1 ));
     } else if ( typeof methodOrOptions === 'object' || ! methodOrOptions ) {
       return methods.init.apply( this, arguments );
     } else {
       $.error( 'Method "' +  methodOrOptions + '" does not exist on jQuery.gallery' );
     }    
   };  
})(jQuery);






